<template>
  <div class="px-4">
    <!-- <PageTitle v-bind:title="title" v-bind:admin="false" /> -->

    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    
    <div class="relative py-16 bg-white overflow-hidden">
      
      <div class="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
        <div
          class="relative h-full text-lg max-w-prose mx-auto"
          aria-hidden="true"
        >
          <svg
            class="absolute top-12 left-full transform translate-x-32"
            width="404"
            height="384"
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  class="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="384"
              fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
            />
          </svg>
          <svg
            class="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
            width="404"
            height="384"
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  class="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="384"
              fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
            />
          </svg>
          <svg
            class="absolute bottom-12 left-full transform translate-x-32"
            width="404"
            height="384"
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="d3eb07ae-5182-43e6-857d-35c643af9034"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  class="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="384"
              fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
            />
          </svg>
        </div>
      </div>

      <div class="relative px-4 sm:px-6 lg:px-8">
        <ErrorMessage v-if="error" :error="error" class="mt-2" />
        <Loader v-if="loading" />
        <div v-else>
          <div class="text-lg max-w-prose mx-auto">
            <h1>
              <!-- <span class="block text-base text-center text-indigo-600 font-semibold tracking-wide uppercase" >Article</span> -->
              <span
                class="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl"
                >Школа для пациентов</span
              >
            </h1>

            <div v-if="user && (user.is_cm == 1)" class="mt-3">
              <router-link
                :to="{ name: 'school_edit', params: { id: data.id } }"
                class="text-base font-semibold text-indigo-600 hover:text-indigo-500"
                >Редактировать</router-link
              >
            </div>

          </div>

          <!-- <div v-html="data.description" class="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto"></div> -->
          <div v-html="data.text" class="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto"></div>
        </div>


      </div>
    </div>

  </div>
</template>
<script>
// import PageTitle from "@/components/PageTitle";
import axios from "axios";
import BreadCrumbs from "@/components/BreadCrumbs";
import moment from "moment";
import Loader from "@/components/Loader";
import ErrorMessage from "../components/ErrorMessage.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    BreadCrumbs,
    Loader,
    ErrorMessage,
    // PageTitle,
  },
  data() {
    return {
      title: "",
      image: "",
      id: 0,
      // bcrumbs: {articles_list: 0},
      bcrumbs: '',
      data: null,
      loading: true,
      error: '',
    };
  },
  async mounted() {
    this.loadData()
  },
  computed: {
      ...mapGetters({
          user: "auth/user",
      }),
  },
  methods: {
    myDate(d) {
      return moment(d).format(
          "DD.MM.YYYY"
        );
    },
    async loadData() {
      this.error = "";
      try {
        this.loading = true;
        let response = await axios.get("articles/1");
        this.data = response.data.article;
        // this.bcrumbs = response.data.bcrumbs
        this.loading = false;
      } catch (e) {
        this.error = "Ошибка при загрузке данных";
      }
    },

  },
};
</script>